/**
 * QuoteSuccess — 견적 요청 제출 완료 카드
 *
 * tier에 따라 다른 안내 문구를 표시한다.
 * - standard   : 1영업일 내 이메일·전화 안내
 * - premium    : 대량 고객 응대 (합리적 단가 제안)
 * - enterprise : 전담 매니저 배정, 인프라 컨설팅 포함
 */

import { cn } from '@/lib/utils';
import type { QuoteVolumeTier } from '@/types/qa';

interface QuoteSuccessProps {
  quoteId: string;
  tier: QuoteVolumeTier;
}

const TIER_MESSAGES: Record<
  QuoteVolumeTier,
  { icon: string; title: string; detail: string }
> = {
  standard: {
    icon: '✅',
    title: '견적 요청이 접수되었습니다',
    detail:
      '영업팀이 1영업일 내 입력하신 이메일과 연락처로 안내드리겠습니다.',
  },
  premium: {
    icon: '🌟',
    title: '대량 견적 요청이 접수되었습니다',
    detail:
      '대량 고객님께는 표준 단가보다 합리적인 요금을 제안드립니다.\n영업팀이 1영업일 내 직접 연락드리겠습니다.',
  },
  enterprise: {
    icon: '💎',
    title: '엔터프라이즈 견적 요청이 접수되었습니다',
    detail:
      '전담 매니저가 배정되어 맞춤형 요금과 발송 인프라 컨설팅을 제공해 드립니다.\n영업팀이 1영업일 내 직접 연락드리겠습니다.',
  },
};

export function QuoteSuccess({ quoteId, tier }: QuoteSuccessProps) {
  const msg = TIER_MESSAGES[tier];

  return (
    <div
      className={cn(
        'ml-p-4 ml-rounded-cb-md',
        'ml-bg-gradient-to-br ml-from-brand-50 ml-to-white',
        'ml-border ml-border-brand-200'
      )}
    >
      <div className="ml-text-2xl ml-mb-2">{msg.icon}</div>
      <div className="ml-text-cb-lg ml-font-semibold ml-text-brand-600 ml-mb-2">
        {msg.title}
      </div>
      <div className="ml-text-cb-base ml-text-ink-secondary ml-mb-3 ml-whitespace-pre-line">
        {msg.detail}
      </div>
      <div
        className={cn(
          'ml-mt-3 ml-pt-3 ml-border-t ml-border-brand-200',
          'ml-flex ml-items-center ml-gap-2'
        )}
      >
        <span className="ml-text-cb-xs ml-text-mute">접수번호</span>
        <span className="ml-text-cb-sm ml-font-mono ml-font-semibold ml-text-brand-600">
          {quoteId}
        </span>
      </div>
    </div>
  );
}
